<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-panel weui-panel_access">
        <div class="weui-panel__bd">
          <div class="weui-media-box weui-media-box_text">
            <h4 class="weui-media-box__title">合同章</h4>
            <p class="weui-media-box__desc">
              在采购订单、销售订单等合同单据中使用
            </p>
            <file-field
              v-model="signet.contractFile.url"
              @select="onSelectFile($event, 1)"
            />
          </div>
          <div class="weui-media-box weui-media-box_text">
            <h4 class="weui-media-box__title">财务章</h4>
            <p class="weui-media-box__desc">一般用于公司财务往来的对账或结算</p>
            <file-field
              v-model="signet.financialFile.url"
              @select="onSelectFile($event, 2)"
            />
          </div>
          <div class="weui-media-box weui-media-box_text">
            <h4 class="weui-media-box__title">公章</h4>
            <p class="weui-media-box__desc">
              以公司名义发出的信函、公文、合同、介绍信、证明或其他公司材料均可使用公章
            </p>
            <file-field
              v-model="signet.commonFile.url"
              @select="onSelectFile($event, 0)"
            />
          </div>
          <div class="weui-media-box weui-media-box_text">
            <h4 class="weui-media-box__title">出货章</h4>
            <p class="weui-media-box__desc">仅限于在出货单据中使用</p>
            <file-field
              v-model="signet.deliveryFile.url"
              @select="onSelectFile($event, 3)"
            />
          </div>
          <div class="weui-media-box weui-media-box_text">
            <h4 class="weui-media-box__title">收货章</h4>
            <p class="weui-media-box__desc">仅限于在收货单据中使用</p>
            <file-field
              v-model="signet.receiveFile.url"
              @select="onSelectFile($event, 4)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileField from "@/views/sys/FileField.vue";

export default {
  components: {
    FileField,
  },
  data: function () {
    return {
      signet: {
        commonFile: {
          url: null,
        },
        contractFile: {
          url: null,
        },
        financialFile: {
          url: null,
        },
        deliveryFile: {
          url: null,
        },
        receiveFile: {
          url: null,
        },
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const me = this;
      me.$loading({
        url: "/api/account/company/signet",
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data.commonFile) {
            me.signet.commonFile = data.commonFile;
          }
          if (data.contractFile) {
            me.signet.contractFile = data.contractFile;
          }
          if (data.financialFile) {
            me.signet.financialFile = data.financialFile;
          }
          if (data.deliveryFile) {
            me.signet.deliveryFile = data.deliveryFile;
          }
          if (data.receiveFile) {
            me.signet.receiveFile = data.receiveFile;
          }
        }
      });
    },
    onSelectFile(fileInfo, type) {
      const me = this;
      me.$loading({
        url: "/api/commons/sealsetting/saveCompanySignet",
        method: "POST",
        jsonData: {
          ss_value: type,
          ss_signeturl: fileInfo.fullPath,
          fileInfo,
        },
      })
        .then(function (res) {
          if (res.success) {
            me.$weui.toast("保存成功", 2000);
          } else {
            me.$weui.topTips("保存失败: " + res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("保存失败", 3000);
        });
    },
  },
};
</script>